
class CapViewInternalCstData {
  constructor(config) {
    this.config = config
  }

  // eslint-disable-next-line
  checkPermission(options = {}) {
    return Boolean(this.config)
  }
}

function key() {
  return 'view_internal_cst_data'
}

function create(config) {
  return new CapViewInternalCstData(config)
}

export default {
  key,
  create,
}
